/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ weight: NonNullable<unknown> }} Inventory_Weight_LbsInputs */

const en_inventory_weight_lbs = /** @type {(inputs: Inventory_Weight_LbsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.weight} lbs`)
};

const es_inventory_weight_lbs = /** @type {(inputs: Inventory_Weight_LbsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.weight} lbs`)
};

/**
* | output |
* | --- |
* | "{weight} lbs" |
*
* @param {Inventory_Weight_LbsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const inventory_weight_lbs = /** @type {((inputs: Inventory_Weight_LbsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inventory_Weight_LbsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_inventory_weight_lbs(inputs)
	return es_inventory_weight_lbs(inputs)
});